var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import ViewModal from "../ActivityItem/ViewModal";
import ActivityItemTypeService from "../../../Domain/ActivityItemType/ActivityItemType.service";
import { ViewModalFormFormat } from "../../UI/FormFormat/FormFormat";
import NoteForm from "./NoteForm";
import NoteService from "../../../Services/Note.service";
import useService from "../../Hooks/useService";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import CustomCard from "../../UI/CustomCard/CustomCard";
import FAIcon from "../../UI/FAIcon/FAIcon";
import PersonWithLabel from "../Person/PersonWithLabel/PersonWithLabel";
import ProfilePicture from "../Person/ProfilePicture/ProfilePicture";
import DateService from "../../../Services/Shared/Date.service";
import Loading from "../../UI/Loading/Loading";
import { AlertWarning } from "../../UI/StandardAlerts/StandardAlerts";
const NoteDetailModal = (_a) => {
    var { noteId, onDeleteNote } = _a, modalProps = __rest(_a, ["noteId", "onDeleteNote"]);
    const [noteState, getNote, noteActions] = useService(NoteService.getNote);
    const [canEdit, setCanEdit] = React.useState(false);
    React.useEffect(() => {
        let timeout;
        if (modalProps.isOpen) {
            getNote(noteId).then((note) => {
                if (note.editable) {
                    setCanEdit(true);
                    if (note.editableTimeRemaining > 0) {
                        timeout = setTimeout(() => {
                            setCanEdit(false);
                        }, note.editableTimeRemaining);
                    }
                }
            });
        }
        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [getNote, modalProps.isOpen, noteId]);
    const getNoteTitle = (note) => note.noteTypes && note.noteTypes.length
        ? note.noteTypes.map((noteType) => noteType.name).join(", ")
        : "Note";
    return (_jsx(ViewModal, Object.assign({}, modalProps, { actions: canEdit
            ? [
                {
                    icon: "fal fa-pencil",
                    title: "Edit",
                    // eslint-disable-next-line react/display-name
                    modalBodyAndFooter: (editProps) => noteState.data ? (_jsx(ViewModalFormFormat, { onCancel: editProps.cancelAction, defaultValue: {
                            text: noteState.data.text,
                            noteTypes: noteState.data.noteTypes,
                        }, handleSubmit: (form) => NoteService.updateNoteWithText({
                            noteId,
                            text: form.text,
                            noteTypes: form.noteTypes.map((noteType) => ({
                                id: noteType.id,
                            })),
                        }).then((note) => {
                            noteActions.edit(note);
                            editProps.cancelAction();
                        }), children: (formVals) => (_jsxs("div", { children: [noteState.data && noteState.data.editableUntil && (_jsx(AlertWarning, { className: "mb-3", message: _jsxs("span", { children: ["Editable until", " ", _jsx("strong", { children: DateService.getRelativeString(noteState.data.editableUntil) }), ". This window will automatically close after this time."] }) })), _jsx(NoteForm, Object.assign({}, formVals))] })) })) : null,
                },
                {
                    icon: "fal fa-trash-alt",
                    title: "Delete",
                    // eslint-disable-next-line react/display-name
                    modalBodyAndFooter: (deleteProps) => (_jsx(ViewModalFormFormat, { onCancel: deleteProps.cancelAction, saveButtonContents: (isLoading) => (_jsxs(_Fragment, { children: [isLoading && _jsx(Loading, { addMarginRight: true }), "Ok"] })), handleSubmit: () => NoteService.deleteNote(noteId).then(() => {
                            deleteProps.cancelAction();
                            modalProps.onModalClosed();
                            onDeleteNote();
                        }), children: () => "Are you sure you want to delete this note?" })),
                },
            ]
            : [], activityItemTypeId: ActivityItemTypeService.NoteId, activityItemId: noteId, children: _jsx(ServiceResult, { state: noteState, children: (note) => (_jsxs(_Fragment, { children: [_jsx("div", { className: "row mb-2", children: _jsx("div", { className: "col", children: _jsxs("h2", { children: [_jsx(FAIcon, { icon: ActivityItemTypeService.getIcon(ActivityItemTypeService.NoteId), className: `mr-2 text-${ActivityItemTypeService.getColor(ActivityItemTypeService.NoteId)}` }), getNoteTitle(note)] }) }) }), _jsxs("div", { className: "row", children: [_jsx("div", { className: "col-7", children: _jsx(CustomCard, { title: "Info", headerRightContent: _jsx("small", { className: "text-muted", children: DateService.displayWithTime(note.createdDate) }), className: "h-100", children: _jsx("div", { className: "card-body", children: _jsx("div", { dangerouslySetInnerHTML: { __html: note.text } }) }) }) }), _jsx("div", { className: "col-5", children: _jsx(CustomCard, { title: "People", className: "h-100", children: _jsxs("div", { className: "card-body", children: [note.author && (_jsx("div", { className: "mb-3", children: _jsx(PersonWithLabel, { fullName: note.author.fullName, photo: _jsx(ProfilePicture, { person: note.author, showProfilePicture: true }), label: "Created By" }) })), note.person && (_jsx("div", { className: "mb-3", children: _jsx(PersonWithLabel, { fullName: note.person.fullName, photo: _jsx(ProfilePicture, { person: note.person, showProfilePicture: true }), label: "Student" }) }))] }) }) })] })] })) }) })));
};
export default NoteDetailModal;
